import { render, staticRenderFns } from "./ServiceOrderBillToCustomerComponent.vue?vue&type=template&id=8a96e36c&"
import script from "./ServiceOrderBillToCustomerComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderBillToCustomerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports